import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, PencilIcon, PersonIcon, PlusIcon } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { CurrencyIcon } from '@root/entities/currency/ui'
import {
  existingInviteCodeAtom,
  openChangeInviteCodeDialogEvent,
} from '@root/entities/referral'

import { ReferralCard } from './referral-card-common'

type ReferralCodeCardProps = {}

export const ReferralCardInviteCode: React.FC<ReferralCodeCardProps> = () => {
  const { t } = useTranslation()
  const [existingInviteCode] = useAtom(existingInviteCodeAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const openChangeInviteCodeDialog = useAction(openChangeInviteCodeDialogEvent)

  const renderContent = () => {
    if (!existingInviteCode) {
      return t('referral.invite-code.empty-description')
    }

    return (
      <Content>
        <CodeContainer>
          <CurrencyIcon size={15} currency={nativeCurrency} />
          <div>{existingInviteCode}</div>
        </CodeContainer>
        <div>{t('referral.invite-code.current-code')}</div>
      </Content>
    )
  }

  return (
    <>
      <ReferralCard>
        <ReferralCard.Header>
          <Icon icon={PersonIcon} />
          <ReferralCard.Title>{t('referral.invite-code')}</ReferralCard.Title>

          {existingInviteCode ? (
            <Button
              radius="full"
              size="h24"
              variant="solid"
              color="primary"
              iconLeft={<PencilIcon />}
              onClick={() => {
                openChangeInviteCodeDialog({
                  inviteCode: undefined,
                })
              }}
            />
          ) : (
            <Button
              radius="full"
              size="h24"
              variant="solid"
              color="primary"
              iconLeft={<PlusIcon />}
              onClick={() => {
                openChangeInviteCodeDialog({
                  inviteCode: undefined,
                })
              }}
            />
          )}
        </ReferralCard.Header>
        <ReferralCard.Content>{renderContent()}</ReferralCard.Content>
      </ReferralCard>
    </>
  )
}

const Icon = styled(ReferralCard.Icon)`
  color: var(--up-9);
`

const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  align-items: baseline;
  gap: 6px;
`
const CodeContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 4px;

  color: var(--backgroundA-11);
  font-size: 18px;
  font-weight: 700;
`
